import { Placement } from '@floating-ui/react';

export const DEFAULT_TOOLTIP_PLACEMENT_FALLBACK: Placement = 'bottom-start';
export const DEFAULT_TOOLTIP_OFFSET_FALLBACK: number = 8;
